export default "__VITE_ASSET__BtRS8EkU__"